export function getLastLoadedPage(collectionByPage) {
    const loadedPages = Object.keys(collectionByPage).map((page) => parseInt(page, 10));
    return Math.max(...loadedPages);
}
